import { FilterObject } from './filters/filter-object';
import { Injectable } from '@angular/core';
import * as lodash from 'lodash';

@Injectable()
export class AsiFilterService {

  filterList(items: Array<any>, filters: Array<FilterObject<any>>) {
    if (lodash.isEmpty(items) || lodash.isEmpty(filters)) {
      return items;
    }

    let result = [];
    result = items.filter(obj => {
      let filtered = true;
      filters.forEach(filter => {
        filtered = filtered && filter.filter(obj)
      })
      return filtered;
    });

    return result;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/asi-filter.service.ts